import Img1 from "../assets/images/garantia01.jpg"
import Img2 from "../assets/images/venta01.jpg"
export default [
  {
    title: "ASESORÍA",
    text:
      "Nos mantenemos expectantes a las necesidades informativas de nuestros clientes. Atenderlos nos brinda oportunidades de aprendizaje que enriquecen nuestra ESCUELA DE CARROCEROS.",
    image: Img2,
    url:'#contact',
    textAlt: [
      {
        text: "Si requieres asesoría sobre cualquier aspecto de carrocería, solicítalo en el siguiente link:  ",
        
      },
    ],
  },
  {
    title: "GARANTÍA",
    botonText: "Reporte de falla",
    url: "#contact",
    text:
      "Garantizamos la calidad de nuestros productos sustentado en una EXPERIENCIA GENERACIONAL de fabricación de carrocerías para ómnibus. Contamos con un equipo de profesionales en el área de INGENIERÍA DEL PRODUCTO por lo que estamos preparados para atender las necesidades y/o problemas de operación de tu carrocería.",
    textAlt: [
      { text: "Reportar tu caso en el siguiente formulario:" },
    ],

    image: Img1,
  },
  {
    title: "VENTA DE REPUESTOS",
    targetBlanck: true,
    iconWhat: true,
    botonText: "Venta repuestos",
    url:
      "https://api.whatsapp.com/send?phone=51938241444&text=Hola INTRAMET. Deseo comprar los siguientes repuestos:",
    text:
      "Dentro del GRUPO INTRAMET contamos con alianzas estratégicas con empresas importadoras con el objetivo de mantener un stock de repuestos y accesorios, para abastecer a nuestros clientes.",
    textAlt: [`Describe los accesorios que necesites al siguiente link:`],
    image: Img2,
  },
  {
    title: "MANTENIMIENTO",
    text:
      "Nuestra área de INGENIERÍA DEL PRODUCTO evalúa los resultados del desempeño operativo de nuestras carrocerías y utiliza las conclusiones para la mejora continua de los procesos de fabricación, recomendaciones para el cuidado de la carrocería y programas de mantenimiento.",
    image: Img1,
    targetBlanck:true,
    botonText: "Cuidados de la Carrocería",
    url:'/pdf/CUIDADOSDECARROCERIA.pdf',
    textAlt: [
      {
        text: "",
        condiciones: {
        },
      },
    ],
  },
]
